/**
 * @fileoverview This file initializes Firebase Functions and defines callable functions for API key, index job, and repository management. It exports the `functions` instance and functions like `createApiKey`, `startIndexJob`, `addRepo`, and others. It also connects to the Functions emulator in development.
 */

import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions'
import { app } from '../firebase'
import { isDev } from '../utils/env'

// Initialize Firebase Functions
export const functions = getFunctions(app)

// Connect to the emulator if in local development
if (isDev()) {
  connectFunctionsEmulator(functions, 'localhost', 5001)
}

// API key management functions
export const createApiKey = httpsCallable(functions, 'createApiKeyCallableV2')
export const revokeApiKey = httpsCallable(functions, 'revokeApiKeyCallableV2')

// Index job management functions
export const startIndexJob = httpsCallable(functions, 'startIndexJobCallable')
export const removeModule = httpsCallable(functions, 'removeModuleCallable')

// Auth functions
export const onEmailVerified = httpsCallable(functions, 'onEmailVerified')
export const updateMarketingConsent = httpsCallable(functions, 'updateMarketingConsent')

// GitHub functions
export const initiateGitHubOAuth = httpsCallable(functions, 'initiateGitHubOAuth')
export const getGitHubRepos = httpsCallable(functions, 'getGitHubRepositories')
export const getGitHubRepoBranches = httpsCallable(functions, 'getGitHubRepoBranches')

// Repository tracking functions
export const addRepo = httpsCallable(functions, 'addRepoToRef')
export const removeRepo = httpsCallable(functions, 'removeRepoFromRef')
export const refreshStats = httpsCallable(functions, 'refreshRepoStats')

// Account management functions
export const deleteUserCallable = httpsCallable(functions, 'deleteUserCallable')
